import classNames from 'classnames';
import React, { ElementType, ReactNode } from 'react';
import { FiInfo } from 'react-icons/fi';
import { WrappedFieldMetaProps } from 'redux-form';

type LabelProps = {
  label?: string;
  showlabel?: boolean;
  placeholder?: string;
  id?: string;
  className?: string;
  icon?: ElementType;
  children: ReactNode;
  meta: WrappedFieldMetaProps;
};

const Label = ({
  className,
  showlabel = true,
  label = '',
  meta: { error },
  children,
  icon: Icon,
  placeholder = '',
  id
}: LabelProps) => (
  <div className={classNames('flex flex-col mb-8 relative', className)}>
    {showlabel && (
      <label
        className="text-xs leading-loose mb-1 text-gray-700 font-bold font-display"
        htmlFor={id}
      >
        {label || placeholder}
      </label>
    )}
    {Icon && (
      <Icon className="absolute top-2 md:top-4 left-2 md:left-3 text-2xl text-gray-700" />
    )}
    {children}
    {!!error && (
      <span
        className={classNames(
          'font-body text-sm text-red-600 flex items-center'
        )}
      >
        <FiInfo className={classNames('text-xs text-red-600 mr-2')} />
        {error}
      </span>
    )}
  </div>
);

export default Label;
